import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Button, Search, Icon } from 'semantic-ui-react'
import { ProvinceDataContainer, DataSection } from './styled'
import { AdminContainer } from '../../styled'
import { rootPath, adminPath, masterDataPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'
import { getProvinces, getDistricts, getSubDistricts } from 'ducks/dataManagement'
import DataCell from './DataCell'
import ProvinceModal from './ProvinceModal'
import DistrictModal from './DistrictModal'
import SubDistrictModal from './SubDistrictModal'

import r from 'reactotron-react-js' 

const ProvinceData = (props) => {
  const { user, history, provinces, districts, subDistricts } = props

  useEffect(() => {
    if (provinces.data.length === 0 && provinces.loading === false) {
      props.getProvinces()
    }
  }, [])

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const [provinceId, setProvinceId] = useState(0)
  const [provinceData, setProvinceData] = useState(undefined)
  const [provinceSearch, setProvinceSearch] = useState('')
  const [showProvinceModal, setShowProvinceModal] = useState(false)
  
  const [districtId, setDistrictId] = useState(0)
  const [districtData, setDistrictData] = useState(undefined)
  const [districtSearch, setDistrictSearch] = useState('')
  const [showDistrictModal, setShowDistrictModal] = useState(false)
  
  const [subDistrictId, setSubDistrictId] = useState(0)
  const [subDistrictData, setSubDistrictData] = useState(undefined)
  const [subDistrictSearch, setSubDistrictSearch] = useState('')
  const [showSubDistrictModal, setShowSubDistrictModal] = useState(false)

  const listProvince = () => {
    if (provinceSearch) {
      return provinces.data.filter(p => p.nameTh.includes(provinceSearch)) || []
    } else {
      return provinces.data
    }
  }

  const listDistrict = () => {
    if (districtSearch) {
      return districts.data.filter(d => d.nameTh.includes(districtSearch)) || []
    } else {
      return districts.data
    }
  }

  const listSubDistrict = () => {
    if (subDistrictSearch) {
      return subDistricts.data.filter(d => d.nameTh.includes(subDistrictSearch)) || []
    } else {
      return subDistricts.data
    }
  }

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Province & Relate Data</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'MasterData', content: 'Master & Mapping Data', link: true, onClick: () => history.push(masterDataPath) },
              { key: 'Province', content: 'Province & Relate Data', active: true }
            ]
          }
        />
      </div>
      <ProvinceDataContainer>
        <DataSection>
          <div className='actionSection'>
            <Button icon fluid color='blue' labelPosition='left' onClick={() => setShowProvinceModal(true)}>
              <Icon name='plus' />
              Add Province
            </Button>
            <Button 
              icon 
              fluid 
              color='green' 
              disabled={provinceId === 0} 
              labelPosition='left'
              onClick={() => {
                var selectedProvince = provinces.data.find(p => p.id === provinceId)
                setProvinceData(selectedProvince)
                setShowProvinceModal(true)
              }}
            >
              <Icon name='pencil' />
              Edit Selected Province
            </Button>
          </div>
          <div className='searchSection'>
            <Search onSearchChange={(e, data) => setProvinceSearch(data.value)} fluid showNoResults={false} />
          </div>
          <div className='dataSection'>
            {
              listProvince().map(p => 
                <DataCell 
                  data={p} 
                  selected={p.id === provinceId} 
                  onClick={(value) => {
                    if (value !== provinceId) {
                      setProvinceId(value)
                      setDistrictId(0)
                      setSubDistrictId(0)
                      props.getDistricts(value)
                    }
                  }} 
              />)
            }
          </div>
        </DataSection>
        <DataSection>
          <div className='actionSection'>
            <Button icon fluid color='blue' disabled={provinceId === 0} labelPosition='left' onClick={() => setShowDistrictModal(true)}>
              <Icon name='plus' />
              Add District
            </Button>
            <Button 
              icon 
              fluid 
              color='green' 
              disabled={districtId === 0} 
              labelPosition='left'
              onClick={() => {
                var selectedDistrict = districts.data.find(d => d.id === districtId)
                setDistrictData(selectedDistrict)
                setShowDistrictModal(true)
              }}
            >
              <Icon name='pencil' />
              Edit Selected District
            </Button>
          </div>
          <div className='searchSection'>
            <Search onSearchChange={(e, data) => setDistrictSearch(data.value)} fluid showNoResults={false} />
          </div>
          <div className='dataSection'>
            {
              listDistrict().map(d => 
                <DataCell 
                  data={d} 
                  selected={d.id === districtId} 
                  onClick={(value) => {
                    if (value !== districtId) {
                      setDistrictId(value)
                      setSubDistrictId(0)
                      props.getSubDistricts(provinceId, value)
                    }
                  }} 
                />
              )
            }
          </div>
        </DataSection>
        <DataSection>
          <div className='actionSection'>
            <Button icon fluid color='blue' disabled={districtId === 0} labelPosition='left' onClick={() => setShowSubDistrictModal(true)}>
              <Icon name='plus' />
              Add Sub District
            </Button>
            <Button 
              icon 
              fluid 
              color='green' 
              disabled={subDistrictId === 0} 
              labelPosition='left'
              onClick={() => {
                var selectedSubDistrict = subDistricts.data.find(s => s.id === subDistrictId) || {}
                setSubDistrictData(selectedSubDistrict)
                setShowSubDistrictModal(true)
              }}
            >
              <Icon name='pencil' />
              Edit Selected Sub District
            </Button>
          </div>
          <div className='searchSection'>
          <Search onSearchChange={(e, data) => setSubDistrictSearch(data.value)} fluid showNoResults={false} />
          </div>
          <div className='dataSection'>
            {
              listSubDistrict().map(s => 
                <DataCell 
                  data={s} 
                  selected={s.id === subDistrictId} 
                  onClick={(value) => {
                    if (value !== subDistrictId) {
                      setSubDistrictId(value)
                    }
                  }} 
                />
              )
            }
          </div>
        </DataSection>
      </ProvinceDataContainer>
      {
        showProvinceModal ? 
          <ProvinceModal 
            data={provinceData} 
            onClose={() => {
              setShowProvinceModal(false)
              setProvinceData(undefined)
            }} 
          /> : null
      }
      {
        showDistrictModal ?
          <DistrictModal 
            data={districtData}
            provinceId={provinceId}
            onClose={() => {
              setShowDistrictModal(false)
              setDistrictData(undefined)
            }} 
          /> : null
      }
      {
        showSubDistrictModal ?
          <SubDistrictModal 
            data={subDistrictData}
            provinceId={provinceId}
            districtId={districtId}
            onClose={() => {
              setShowSubDistrictModal(false)
              setSubDistrictData(undefined)
            }} 
          /> : null
      }
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
    provinces: state.dataManagement.provinces,
    districts: state.dataManagement.districts,
    subDistricts: state.dataManagement.subDistricts,
  })
}

const mapDispatchToProps = {
  toggleSideMenu,
  getProvinces, 
  getDistricts, 
  getSubDistricts
}

export default connect(mapStateToProps, mapDispatchToProps)(ProvinceData)